import React, { useEffect, useRef } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import VistaPreviaDetalle from "../../components/promociones/VistaPreviaDetalle";
import usePromocionesStore from "../../store/promocionesStore";

const EditorPage = ({name }) => {
  const { datos, handleChange, error } = usePromocionesStore();
  const refIframes = useRef(null);
  const toolbarOptions = [
    [{ size: [ 'small', false, 'large' ]}],
    ['bold', 'italic', 'underline'],
    ['link', 'image'],
    [{ 'align': [] }],  
  ];

  const modules = {
    toolbar: {
      container: toolbarOptions,
    },
  };

  const enviarImagenFlutter = () => {
    refIframes.current.contentWindow.postMessage(
      { tipo: 'demo_promocion', payload: datos.detalle },
      'https://cms.jphoteles.com.mx/demo_promocion' // debe coincidir exactamente
    );
  }

  useEffect(() => {
    enviarImagenFlutter();
  }, [datos.detalle]);

  return (
    <>
      <div className="row mt-5" style={{ display: 'flex', height: '100%',  }}>
        <div className="col-md-8" style={{}}>
        <ReactQuill theme="snow" value={datos.detalle} onChange={(value) => handleChange({ target: { name: 'detalle', value } })} modules={modules} style={{height: '100%',width: '100%',paddingBottom: '20px', borderColor: error?.[name] ? 'red' : '', borderWidth: error?.[name] ? '1px' : '', borderStyle: error?.[name] ? 'solid' : '', borderRadius: error?.[name] ? '10px' : '' }}  />
        </div>
        {/* Aquí el iframe de 700px */}
        <VistaPreviaDetalle refIframes={refIframes}/>
      </div>
      {
        error?.[name] && (
            <div className="" style={{color: 'var(--danger-main)', fontSize: '15px',marginTop: '7px'}}>
                {error?.[name]}
            </div>
        )
      }
    </>
  );
};

export default EditorPage;